module.exports = {
  URL: process.env.REACT_APP_BASE_API_URL,
  s3_buckets: {
    IMAG_UPLOAD: process.env.REACT_APP_S3_BUCKETS_IMAG_UPLOAD,
    FIRMWARE_UPLOAD: process.env.REACT_APP_S3_BUCKETS_FIRMWARE_UPLOAD,
    EXE_UPLOAD: process.env.REACT_APP_S3_BUCKETS_EXE_UPLOAD,
  },
}
